import { Filter, Measurement, MeasureService, MSorting } from '../http/meas-service';
import { Store } from './store';

export class PaginationMeasStore extends Store<Measurement, Filter, MSorting> {
    constructor() {
        super({}, { column: 'measure', order: 'asc' }, 100);
    }

    protected override async getItems(): Promise<Measurement[]> {
        const response = await MeasureService.getMeasures(this.filter, this.sorting, this.limit);
        return response.data;
    }

    protected override async getSize(): Promise<number> {
        const response = await MeasureService.size(this.filter);
        return response.data;
    }
}
